import { render, staticRenderFns } from "./tabList.vue?vue&type=template&id=717f0fa4&scoped=true"
import script from "./tabList.vue?vue&type=script&lang=js"
export * from "./tabList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "717f0fa4",
  null
  
)

export default component.exports